import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'

import en from './locales/en.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import it from './locales/it.json'

// Read the initial locale from the html[lang] attribute set by the Server Component.
// This prevents a flash of the wrong language on hydration.
const initialLng = typeof document !== 'undefined' ? document.documentElement.lang || 'it' : 'it'

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es }
    },
    lng: initialLng,
    fallbackLng: 'it',
    interpolation: { escapeValue: false }
  })
}

export default i18n
